import {useMutation, useQuery} from '@tanstack/react-query';
import {
  additionMessageToBackground,
  batchReportExportToExcel,
  deleteReport,
  exportDocumentAuditReport,
  exportExcelGapReport,
  exportReviewerCounts,
  exportReviewLoginExcel,
  exportReviewProgressAssignment,
  exportTimlineGapReportToExcel,
  fetchSubtallyReport,
  fetchSubtallyResult,
  fetchTallyReport,
  fetchTallyResult,
  getABMDocJSONResultData,
  getABMJSONResultData,
  getABMReportViewData,
  getDocListMasterIDForExport,
  getDocReport,
  getDocumentAuditReportResultView,
  getDocumentMasterDocId,
  getExportDataFormat,
  getExportView,
  getLeftPanel,
  getLeftPanelData,
  getLeftPanelReport,
  getNavigationMasterList,
  getReportDocId,
  getReportDocListMasterID,
  getReportDocumentMasterDocId,
  getReportLanding,
  getReportState,
  getReportTimeline,
  getReportTimelineResult,
  getReviewerProductivityReport,
  getReviewerProductivityView,
  getReviewerTimeOnlineReport,
  getReviewerTimeOnlineView,
  getReviewReport,
  getReviewResultsSources,
  getSavedReportList,
  getSearchTermAddMessage,
  getSourceView,
  getSubTallyExportReport,
  getSubTallyMetadataFilters,
  getTallyExportReport,
  getTallyMetadataFilters,
  getTimelineToReportMasterDocId,
  getTimelineTotallyDocMasterId,
  getTimelineView,
  getTotalSelectedCounts,
  getUserList,
  getUserListGridData,
  redirectReport,
  reviewerCountExport,
  runExportReport,
  saveABMReportFilterData,
  saveAssignGroupGridReportData,
  saveDocumentAuditReportData,
  saveUserActivityReportData,
  getUserActivityReportResultView,
  saveExportDataReport,
  saveReport,
  SaveReviewResultsReportData,
  saveTimelineReportXml,
  saveUserLoginActivity,
  tagCountReport,
  tagCountView,
  timelineBackground,
  timelineDoc,
  getReviewResults,
  exportReviewResultExcel,
  saveReviewerProgressReportData,
  getRPRGridData,
  exportReviewProgressReviewer,
  getReviewLeftPanel,
  getReviewerCountReport,
  getReviewerCountReportView,
  exportReviewerCountsReport,
  exportUserActivityReport,
} from '../../api/endpoints/reportingApi';
import {DocumentListSourceInfo} from '../../api/types/document.type';
import {
  AdditionMessageToBackgroundRequest,
  DocumentAuditReportRequestBody,
  DocumentAuditReportResponse,
  DocumentAuditSaveRequestPayload,
  DocumentAuditSaveResponse,
  UserActivityReportRequestBody,
  UserActivityReportResponse,
  UserActivitySaveRequestPayload,
  UserActivitySaveResponse,
  ExportDataReportRequest,
  ExportDataReportResponse,
  ExportDocumentAuditReportRequestPayload,
  ExportDocumentAuditReportResponse,
  GetABMDocJSONResultDataResponse,
  GetABMDocJSONResultReqPayload,
  GetABMJSONResultDataResponse,
  GetABMJSONResultReqPayload,
  GetABMViewDataReqPayload,
  GetABMViewDataResponse,
  GetDocumentMasterDocIdResponse,
  GetReviewReportRequest,
  GetReviewReportResponse,
  GetReviewResultsPayload,
  GetTimeLineResponse,
  GetTimelineToReportMasterDocIdResponse,
  GetTimelineTotallyDocMasterDocIdResponse,
  IApiError,
  IDeleteReportResponse,
  IGetDocReportRequest,
  IGetDocReportResponse,
  IGetExportViewRequest,
  IGetExportViewResponse,
  IGetReportDocIdRequest,
  IGetReportDocIdResponse,
  IGetReportMasterDocListIdRequest,
  IGetReportMasterDocListIdResponse,
  IReportLandingRequestBody,
  IReportLandingResponse,
  ISavedReportListResponse,
  ISaveExportDataReportRequestBody,
  ISaveReportRequestBody,
  ISaveReportResponse,
  ISaveTimelineGapReportRequestBody,
  ISourceViewRequestBody,
  ISourceViewResponse,
  ISubtallyDataRequestBody,
  ISubtallyDataResponseBody,
  ISubtallyResultRequestBody,
  ISubtallyResultResponseBody,
  ITallyDataRequestBody,
  ITallyDataResponseBody,
  ITallyResultRequestBody,
  ITallyResultResponseBody,
  LeftPanelDataResponse,
  LeftPanelReportResponse,
  NavigationMasterListRequestPayload,
  NavigationMasterListResponse,
  RedirectReportRequestPayload,
  RedirectReportResponse,
  ReportStateResponse,
  ReviewerCountsExportRequest,
  ReviewerCountsExportResponse,
  ReviewerProductivityReportPayload,
  ReviewerProductivityViewPayload,
  ReviewerTimeOnlineRequest,
  ReviewerTimeOnlineResponse,
  ReviewerTimeOnlineViewResponse,
  ReviewerTimeViewRequest,
  ReviewLoginExportExcelRequest,
  ReviewLoginExportExcelResponse,
  ReviewProgressAssignmentExportRequest,
  ReviewResultsReport,
  SaveABMReportDataReqPayload,
  SaveAssignGroupGridReportDataReqPayload,
  SaveAssignGroupGridReportDataResponse,
  SaveReviewResultsReportDataPayload,
  SaveReviewResultsReportDataResponse,
  SearchTermAddMessageRequestPayload,
  SearchTermTotalSelectedCountRequestPayload,
  SearchTermTotalSelectedCountResponse,
  SubTallyExportRequestBody,
  SubTallyExportResponseBody,
  TagCountReportReqPayload,
  TagCountReportResponse,
  TagCountReportViewReqPayload,
  TagCountReportViewResponse,
  TallyExportRequestBody,
  TallyExportResponseBody,
  UserLoginActivityJsonReqPayload,
  UserLoginActivityJsonResponse,
  UserLoginActivitySaveRequestPayload,
  UserLoginActivitySaveResponse,
  ReviewResultExportExcelRequest,
  ReviewResultExportExcelResponse,
  ReviewerProgressPayload,
  GetRPRGridDataResponse,
  ReviewProgressReviewerExportRequest,
  ReviewerCountReportResponse,
  ReviewerLeftPanelResponse,
  ReviewerCountReportRequest,
  ReviewerCountViewReportResponse,
  ReviewerCountViewReportRequest,
  ReviewerCountsExportReviewReportsRequest,
  ExportUserActivityReportResponse,
  ExportUserActivityReportRequestPayload,
} from '../../api/types/reportingApi.type';
import {DocMetadataFilter, ReviewResultsSources} from '../../shared/interfaces';

export const useReportLanding = (payload: IReportLandingRequestBody) => {
  return useQuery<IReportLandingResponse, Error>({
    queryKey: ['reportLanding', payload],
    queryFn: () => getReportLanding(payload),
  });
};

export const useSourceView = (payload: ISourceViewRequestBody) => {
  return useQuery<ISourceViewResponse, Error>({
    queryKey: ['sourceView', payload],
    queryFn: () => getSourceView(payload),
    enabled: false,
  });
};

export const useTallyReport = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<ITallyDataResponseBody, Error, ITallyDataRequestBody>({
    mutationFn: fetchTallyReport,
    mutationKey: ['tallyReport'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useTallyResult = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<ITallyResultResponseBody, Error, ITallyResultRequestBody>({
    mutationFn: fetchTallyResult,
    mutationKey: ['tallyResult'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSubtallyReport = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    ISubtallyDataResponseBody,
    Error,
    ISubtallyDataRequestBody
  >({
    mutationFn: fetchSubtallyReport,
    mutationKey: ['subtallyReport'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSubTallyResult = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    ISubtallyResultResponseBody,
    Error,
    ISubtallyResultRequestBody
  >({
    mutationFn: fetchSubtallyResult,
    mutationKey: ['subtallyResult'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetTallyMetadataFilterQuery = () => {
  return useQuery<DocMetadataFilter[], Error>({
    queryKey: ['tallyMetadataFilter'],
    queryFn: () => getTallyMetadataFilters(),
  });
};

export const useGetSubTallyMetadataFilterQuery = () => {
  return useQuery<DocMetadataFilter[], Error>({
    queryKey: ['subTallyMetadataFilter'],
    queryFn: () => getSubTallyMetadataFilters(),
  });
};

export const useGetUserListQuery = () => {
  return useQuery<DocMetadataFilter[], Error>({
    queryKey: ['userList'],
    queryFn: () => getUserList(),
  });
};

export const useGetReviewResultsSources = (repotId?: number) => {
  return useQuery<ReviewResultsSources[], Error>({
    queryKey: ['reviewResultsSources', repotId],
    queryFn: () => getReviewResultsSources(),
    gcTime: 0,
    staleTime: 1000 * 60 * 10,
  });
};

export const useGetLeftPanelData = (reportTypeCode: number) => {
  return useQuery<LeftPanelDataResponse, Error>({
    queryKey: ['leftPanelData', reportTypeCode],
    queryFn: () => getLeftPanelData(reportTypeCode),
    gcTime: 0,
    staleTime: 1000 * 60 * 10,
    enabled: reportTypeCode > 0,
  });
};

export const useGetReportGridDataQuery = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    UserLoginActivityJsonResponse,
    Error,
    UserLoginActivityJsonReqPayload
  >({
    mutationFn: (payload) => getUserListGridData(payload),
    mutationKey: ['UserListGridData'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetReportTimelineView = (
  onSuccess?: (data: object) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<object, Error, {reportID: number}>({
    mutationFn: (payload) => getTimelineView(payload),
    mutationKey: ['TimelineView'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetReportTimeline = (
  onSuccess?: (data: GetTimeLineResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<GetTimeLineResponse, Error, Record<string, any>>({
    mutationFn: (payload) => getReportTimeline(payload),
    mutationKey: ['ReportTimeline'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

//To genrate report including REPORT ID
export const useGetReportTimelineResult = (
  onSuccess?: (data: Record<string, any>) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<Record<string, any>, Error, Record<string, any>>({
    mutationFn: (payload) => getReportTimelineResult(payload),
    mutationKey: ['ReportTimelineResult'],
    onSuccess: (data: Record<string, any>) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportUserActivityReport = (
  onSuccess?: (data: ExportUserActivityReportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ExportUserActivityReportResponse,
    IApiError,
    ExportUserActivityReportRequestPayload
  >({
    mutationFn: (payload) => exportUserActivityReport(payload),
    mutationKey: ['userActivityExport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetUserActivityReportResultData = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    UserActivityReportResponse,
    Error,
    UserActivityReportRequestBody
  >({
    mutationFn: (payload: UserActivityReportRequestBody) =>
      getUserActivityReportResultView(payload),
    mutationKey: ['useGetUserActivityReportResultData'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSaveUserActivityReportData = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    UserActivitySaveResponse,
    Error,
    UserActivitySaveRequestPayload
  >({
    mutationFn: (payload: UserActivitySaveRequestPayload) => {
      return saveUserActivityReportData(payload);
    },
    mutationKey: ['saveUserActivityReportData'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSaveDocumentAuditReportData = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    DocumentAuditSaveResponse,
    Error,
    DocumentAuditSaveRequestPayload
  >({
    mutationFn: (payload: DocumentAuditSaveRequestPayload) => {
      return saveDocumentAuditReportData(payload);
    },
    mutationKey: ['saveDocumentAuditReportData'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportDocumentAuditReport = (
  onSuccess?: (data: ExportDocumentAuditReportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ExportDocumentAuditReportResponse,
    IApiError,
    ExportDocumentAuditReportRequestPayload
  >({
    mutationFn: (payload) => exportDocumentAuditReport(payload),
    mutationKey: ['documentAuditExport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetDocumentAuditReportResultData = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    DocumentAuditReportResponse,
    Error,
    DocumentAuditReportRequestBody
  >({
    mutationFn: (payload: DocumentAuditReportRequestBody) =>
      getDocumentAuditReportResultView(payload),
    mutationKey: ['getDocumentAuditReportResultData'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSaveUserLoginActivity = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    UserLoginActivitySaveResponse,
    Error,
    UserLoginActivitySaveRequestPayload
  >({
    mutationFn: (payload) => saveUserLoginActivity(payload),
    mutationKey: ['userActivitySave'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSaveReviewResultsReportData = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<SaveReviewResultsReportDataResponse, Error, any>({
    mutationFn: (payload) => SaveReviewResultsReportData(payload),
    mutationKey: ['useSaveReviewResultsReportData'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useReviewResultsViewDataQuery = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<ReviewResultsReport, Error, GetReviewResultsPayload>({
    mutationFn: (payload) => getReviewResults(payload),
    mutationKey: ['useReviewResultsViewDataQuery'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSavedReportList = (reportTypeCode: string) => {
  return useQuery<ISavedReportListResponse, Error>({
    queryKey: ['savedReportList', reportTypeCode],
    queryFn: () => getSavedReportList(reportTypeCode),
    enabled: !!reportTypeCode,
  });
};

export const useSaveReport = (
  onSuccess?: (data: ISaveReportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<ISaveReportResponse, IApiError, ISaveReportRequestBody>({
    mutationFn: saveReport,
    mutationKey: ['saveReport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSaveTimelineGapReport = (
  onSuccess?: (data: ISaveReportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ISaveReportResponse,
    IApiError,
    ISaveTimelineGapReportRequestBody
  >({
    mutationFn: saveTimelineReportXml,
    mutationKey: ['saveTimelineGapReport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportDataSaveReport = (
  onSuccess?: (data: ISaveReportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ISaveReportResponse,
    IApiError,
    ISaveExportDataReportRequestBody
  >({
    mutationFn: saveExportDataReport,
    mutationKey: ['saveExportDataReport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const getExportDataSource = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<ExportDataReportResponse, Error, ExportDataReportRequest>({
    mutationFn: (payload) => getExportDataFormat(payload),
    mutationKey: ['exportDataFormat'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useRunReport = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: runExportReport,
    mutationKey: ['runReport'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSearchTermAddMessage = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, SearchTermAddMessageRequestPayload>({
    mutationFn: (payload) => getSearchTermAddMessage(payload),
    mutationKey: ['searchTermAddMessage'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSearchTermSelectedCount = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    SearchTermTotalSelectedCountResponse,
    Error,
    SearchTermTotalSelectedCountRequestPayload
  >({
    mutationFn: (payload) => getTotalSelectedCounts(payload),
    mutationKey: ['searchTermSelectedCount'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useNavigationMasterList = (
  onSuccess?: (response: NavigationMasterListResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    NavigationMasterListResponse,
    Error,
    NavigationMasterListRequestPayload
  >({
    mutationFn: (payload) => getNavigationMasterList(payload),
    mutationKey: ['navigationMasterList'],
    onSuccess: (response) => {
      onSuccess?.(response);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSaveABMReportData = (
  onSuccess?: (data: {reportID: number; notificationID: number}) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    {reportID: number; notificationID: number},
    Error,
    SaveABMReportDataReqPayload
  >({
    mutationFn: (payload) => saveABMReportFilterData(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetABMViewData = (payload: GetABMViewDataReqPayload) => {
  return useQuery<GetABMViewDataResponse, Error>({
    queryKey: ['getABMViewData', payload],
    queryFn: async () => getABMReportViewData(payload),
    staleTime: 1000 * 60 * 10,
    gcTime: 0,
    enabled: false,
  });
};

export const useGetABMJSONResultData = (
  onSuccess?: (data: GetABMJSONResultDataResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    GetABMJSONResultDataResponse,
    Error,
    GetABMJSONResultReqPayload
  >({
    mutationFn: async (payload) => getABMJSONResultData(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetABMDocJSONResultData = (
  onSuccess?: (data: GetABMDocJSONResultDataResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    GetABMDocJSONResultDataResponse,
    Error,
    GetABMDocJSONResultReqPayload
  >({
    mutationFn: async (payload) => getABMDocJSONResultData(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSaveAssignGroupGridReportData = (
  onSuccess?: (data: SaveAssignGroupGridReportDataResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    SaveAssignGroupGridReportDataResponse,
    Error,
    SaveAssignGroupGridReportDataReqPayload
  >({
    mutationFn: (payload) => saveAssignGroupGridReportData(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetReviewReport = (
  onSuccess?: (data: GetReviewReportResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<GetReviewReportResponse, Error, GetReviewReportRequest>({
    mutationFn: async (payload) => getReviewReport(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useDeleteReport = (
  onSuccess?: (data: IDeleteReportResponse) => void,
  onError?: (error: Error) => void
) => {
  return useMutation<IDeleteReportResponse, Error, number>({
    mutationFn: (reportId) => deleteReport(reportId),
    mutationKey: ['deleteReport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useLeftPanelReport = (reportId: number, enabled?: boolean) => {
  return useQuery<LeftPanelReportResponse, any>({
    queryKey: ['leftPanelReport', reportId],
    queryFn: () => getLeftPanelReport(reportId),
    enabled: enabled ?? !!reportId,
    gcTime: 0,
    staleTime: 1000 * 60 * 10,
  });
};

export const useExportReviewerCounts = (
  onSuccess?: (data: ReviewerCountsExportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ReviewerCountsExportResponse,
    IApiError,
    ReviewerCountsExportRequest
  >({
    mutationFn: (payload) => exportReviewerCounts(payload),
    mutationKey: ['reviewerCountsExport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportReviewProgressAssignment = (
  onSuccess?: (data: ReviewerCountsExportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ReviewerCountsExportResponse,
    IApiError,
    ReviewProgressAssignmentExportRequest
  >({
    mutationFn: (payload) => exportReviewProgressAssignment(payload),
    mutationKey: ['reviewProgressAssignmentExport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useTallyExport = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<TallyExportResponseBody, Error, TallyExportRequestBody>({
    mutationFn: getTallyExportReport,
    mutationKey: ['tallyexport'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSubTallyExport = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    SubTallyExportResponseBody,
    Error,
    SubTallyExportRequestBody
  >({
    mutationFn: getSubTallyExportReport,
    mutationKey: ['subTallyexport'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportExcelGapReport = (
  onSuccess?: () => void,
  onError?: (error: Error) => void
) => {
  return useMutation<
    any,
    Error,
    {queryParam: {gapReportType: string}; payload: Record<string, any>}
  >({
    mutationFn: async (param) => exportExcelGapReport(param),
    mutationKey: ['exportExcelGapReport'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetDocumentMasterDocId = (
  onSuccess?: (data: GetDocumentMasterDocIdResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<GetDocumentMasterDocIdResponse, Error, object>({
    mutationFn: (payload) => getDocumentMasterDocId(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useDocReportId = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<IGetReportDocIdResponse, Error, IGetReportDocIdRequest>({
    mutationFn: getReportDocId,
    mutationKey: ['reportdocid'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
export const useDocReport = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<IGetDocReportResponse, Error, IGetDocReportRequest>({
    mutationFn: getDocReport,
    mutationKey: ['docReport'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportView = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<IGetExportViewResponse, Error, IGetExportViewRequest>({
    mutationFn: getExportView,
    mutationKey: ['exportview'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useTimelineToReportMasterDocId = (
  onSuccess?: (data: GetTimelineToReportMasterDocIdResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<GetTimelineToReportMasterDocIdResponse, Error, object>({
    mutationFn: (payload) => getTimelineToReportMasterDocId(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useTimelineTotallyReportMasterDocId = (
  onSuccess?: (data: GetTimelineTotallyDocMasterDocIdResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<GetTimelineTotallyDocMasterDocIdResponse, Error, object>({
    mutationFn: (payload) => getTimelineTotallyDocMasterId(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useTimelineBackground = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, string>({
    mutationFn: timelineBackground,
    mutationKey: ['timelineBackground'],
    onSuccess,
    onError,
  });
};

export const useReportDocListMasterID = (
  onSuccess?: (data: number) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<number, Error, DocumentListSourceInfo>({
    mutationFn: getReportDocListMasterID,
    mutationKey: ['getReportDocListMasterID'],
    onSuccess,
    onError,
  });
};

export const useGetDocListMasterIDForExport = (
  onSuccess?: (data: number) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<number, Error, DocumentListSourceInfo>({
    mutationFn: getDocListMasterIDForExport,
    mutationKey: ['getDocListMasterIDForExport'],
    onSuccess,
    onError,
  });
};

export const useGetReportDocumentMasterDocId = (
  onSuccess?: (data: IGetReportMasterDocListIdResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    IGetReportMasterDocListIdResponse,
    Error,
    IGetReportMasterDocListIdRequest
  >({
    mutationFn: (payload) => getReportDocumentMasterDocId(payload),
    mutationKey: ['getReportDocumentMasterDocId'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useTimelineDoc = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, string>({
    mutationFn: timelineDoc,
    mutationKey: ['timelineDoc'],
    onSuccess,
    onError,
  });
};

export const useAdditionMessageToBackground = (
  onSuccess?: (data: {status: number}) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    {status: number},
    Error,
    AdditionMessageToBackgroundRequest
  >({
    mutationFn: (payload) => additionMessageToBackground(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useRedirectReport = (
  onSuccess?: (data: RedirectReportResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    RedirectReportResponse,
    Error,
    RedirectReportRequestPayload
  >({
    mutationFn: (payload) => redirectReport(payload),
    mutationKey: ['redirectReport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useBatchReportExportToExcel = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: (payload) => batchReportExportToExcel(payload),
    mutationKey: ['batch-report-exporttoexcel'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useReviewLeftPanel = (reportTypeCode: number, enabled = true) => {
  return useQuery<ReviewerLeftPanelResponse, Error>({
    queryKey: ['reviewLeftPanel', reportTypeCode],
    queryFn: () => getReviewLeftPanel({reportTypeCode}),
    enabled: enabled && !!reportTypeCode,
  });
};

export const useReviewerCountReport = (
  onSuccess?: (data: ReviewerCountReportResponse) => void,
  onError?: (error: Error) => void
) => {
  return useMutation<
    ReviewerCountReportResponse,
    Error,
    ReviewerCountReportRequest
  >({
    mutationKey: ['reviewerCountReport'],
    mutationFn: getReviewerCountReport,
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useReviewerCountViewReport = (
  onSuccess?: (data: ReviewerCountViewReportResponse) => void,
  onError?: (error: Error) => void
) => {
  return useMutation<
    ReviewerCountViewReportResponse,
    Error,
    ReviewerCountViewReportRequest
  >({
    mutationFn: getReviewerCountReportView,
    mutationKey: ['reviewerCountViewReport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportUserLoginActivity = (
  onSuccess?: (data: ReviewLoginExportExcelResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ReviewLoginExportExcelResponse,
    IApiError,
    ReviewLoginExportExcelRequest
  >({
    mutationFn: (payload) => exportReviewLoginExcel(payload),
    mutationKey: ['reviewLoginExportExcel'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportReviewResults = (
  onSuccess?: (data: ReviewResultExportExcelResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ReviewResultExportExcelResponse,
    IApiError,
    ReviewResultExportExcelRequest
  >({
    mutationFn: (payload) => exportReviewResultExcel(payload),
    mutationKey: ['reviewResultExportExcel'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetReportState = (
  reportId: string | number,
  enabled?: boolean
) => {
  return useQuery<ReportStateResponse, Error>({
    queryKey: ['reportState', reportId],
    queryFn: async () => getReportState(reportId),
    staleTime: 1000 * 60 * 10,
    gcTime: 0,
    enabled: enabled ?? false,
  });
};

export const useTimelineGapExporrToExcel = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: (payload) => exportTimlineGapReportToExcel(payload),
    mutationKey: ['export-excle-timeline'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useLeftPanel = (reportTypeCode: number, enabled = true) => {
  return useQuery<LeftPanelReportResponse, Error>({
    queryKey: ['leftPanel', reportTypeCode],
    queryFn: () => getLeftPanel(reportTypeCode),
    staleTime: 1000 * 60 * 10,
    gcTime: 0,
    enabled: enabled,
  });
};

export const useGetReviewerTimeOnline = (
  onSuccess?: (data: ReviewerTimeOnlineResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    ReviewerTimeOnlineResponse,
    Error,
    ReviewerTimeOnlineRequest
  >({
    mutationFn: async (payload) => getReviewerTimeOnlineReport(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useReviewerProductivityReport = (
  onSuccess?: (data: Record<string, any>) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    Record<string, any>,
    IApiError,
    ReviewerProductivityReportPayload
  >({
    mutationFn: (payload) => getReviewerProductivityReport(payload),
    mutationKey: ['reviewerProductivityReport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetReviewerTimeOnlineView = (
  onSuccess?: (data: ReviewerTimeOnlineViewResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    ReviewerTimeOnlineViewResponse,
    Error,
    ReviewerTimeViewRequest
  >({
    mutationFn: async (payload) => getReviewerTimeOnlineView(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useTagCountReport = (
  onSuccess?: (data: TagCountReportResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<TagCountReportResponse, Error, TagCountReportReqPayload>({
    mutationFn: async (payload) => tagCountReport(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useTagCountView = (
  onSuccess?: (data: TagCountReportViewResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    TagCountReportViewResponse,
    Error,
    TagCountReportViewReqPayload
  >({
    mutationFn: async (payload) => tagCountView(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
export const useReviewerProductivityView = (
  onSuccess?: (data: Record<string, any>) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    Record<string, any>,
    IApiError,
    ReviewerProductivityViewPayload
  >({
    mutationFn: (payload) => getReviewerProductivityView(payload),
    mutationKey: ['reviewerProductivityView'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useReviewerCountExport = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: (payload) => reviewerCountExport(payload),
    mutationKey: ['reviewer-count-export'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useSaveReviewerProgressReportData = (
  onSuccess?: (data: any) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, ReviewerProgressPayload>({
    mutationFn: (payload) => saveReviewerProgressReportData(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetRPRGridData = (
  onSuccess?: (data: GetRPRGridDataResponse) => void,
  onError?: (err: Error) => void
) => {
  return useMutation<GetRPRGridDataResponse, Error, GetReviewReportRequest>({
    mutationFn: async (payload) => getRPRGridData(payload),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportReviewProgressReviewer = (
  onSuccess?: (data: ReviewerCountsExportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ReviewerCountsExportResponse,
    IApiError,
    ReviewProgressReviewerExportRequest
  >({
    mutationFn: (payload) => exportReviewProgressReviewer(payload),
    mutationKey: ['reviewProgressReviewerExport'],
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useExportReviewerCountsReport = (
  onSuccess?: (data: ReviewerCountsExportResponse) => void,
  onError?: (error: IApiError) => void
) => {
  return useMutation<
    ReviewerCountsExportResponse,
    IApiError,
    ReviewerCountsExportReviewReportsRequest
  >({
    mutationFn: (payload) => exportReviewerCountsReport(payload),
    mutationKey: ['reviewerCountsExportReviewReports'],
    onSuccess: (data) => onSuccess?.(data),
    onError: (error) => onError?.(error),
  });
};
